import React from "react";
import logo from "./logo.svg";
import "./App.css";
import MyRouter from "./routes";

function App() {
  return (
    <div className="App">
      <div>
        <MyRouter />
      </div>
    </div>
  );
}

export default App;
